import {combine} from 'effector';

import {$configs} from './configs';
import {getReasonsWithLabelsFromTanker} from './utils';

export const $refundReasons = $configs.map(
    state => getReasonsWithLabelsFromTanker(state?.callform_cost_change_reasons?.refund_reasons || []),
);

export const $overchargeReasons = $configs.map(
    state => getReasonsWithLabelsFromTanker(state?.callform_cost_change_reasons?.overcharge_reasons || []),
);

export const $costChangeReasons = combine(
    $refundReasons,
    $overchargeReasons,
    (refundReasons, overchargeReasons) => ([...refundReasons, ...overchargeReasons]),
);

export const $costChangeReasonsWithoutComissionChange = $costChangeReasons.map(
    reasons => reasons.reduce<string[]>((acc, {dont_change_comission, value}) => {
        if (dont_change_comission) {
            acc.push(value);
        }

        return acc;
    }, []),
);
